export default __webpack_public_path__ + "static/sliderblock-61ee6dee18d8bd872cb2146e74b1a6e4.gif";